import React from 'react'

const Compromiso = () => {
  return (
    <section id='compromiso' className="text-gray-700 body-font border-t border-gray-200">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-col text-center w-full mb-20">
          <h2 className="text-xs text-blue-600 tracking-widest font-medium title-font mb-1">NUESTRO COMPROMISO CONTIGO</h2>
          <h1 className="sm:text-3xl text-2xl font-medium title-font text-gray-900">Bitnea te ofrece:</h1>
        </div>
        <div className="flex flex-wrap -m-4">
          {[
            {
              titulo: "Compromiso Total",
              icono: (
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
              ),
              texto: "En Bitnea, nuestro compromiso va más allá de las expectativas. Nos dedicamos a entender profundamente tus objetivos y necesidades, trabajando incansablemente para alcanzarlos. Cada proyecto es tratado con la máxima dedicación y atención al detalle, asegurando resultados excepcionales.",
              hoverTexto: "Tu visión es nuestra prioridad. Desde la primera reunión hasta la entrega final, nos enfocamos en crear un impacto real para ti y tu negocio."
            },
            {
              titulo: "Excelencia Profesional",
              icono: (
                <>
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </>
              ),
              texto: "Nuestro equipo está compuesto por profesionales altamente calificados. Utilizamos las últimas tecnologías y mejores prácticas para garantizar un trabajo de la más alta calidad. Cada estrategia está respaldada por años de experiencia y conocimiento especializado.",
              hoverTexto: "Creamos con precisión y pasión. Cada línea de código y cada diseño está pensado para brindar soluciones reales y escalables a largo plazo."
            },
            {
              titulo: "Soluciones Adaptables",
              icono: (
                <>
                  <circle cx="6" cy="6" r="3"></circle>
                  <circle cx="6" cy="18" r="3"></circle>
                  <path d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12"></path>
                </>
              ),
              texto: "Entendemos que cada negocio es único. Por eso, desarrollamos estrategias personalizadas que se adaptan a tus necesidades específicas. Nuestras soluciones son flexibles y escalables, permitiéndote crecer sin restricciones.",
              hoverTexto: "Adaptamos nuestra experiencia a tu realidad. Bitnea evoluciona contigo, entregando resultados que crecen al ritmo de tus metas."
            },
          ].map((card, idx) => (
            <div key={idx} className="p-4 md:w-1/3">
              <div className="relative group rounded-2xl overflow-hidden shadow-lg h-full bg-gray-100 p-8 transition-all duration-300">
                {/* Capa original */}
                <div className="flex flex-col h-full transition-opacity duration-300 group-hover:opacity-0">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 mr-3 inline-flex items-center justify-center rounded-full bg-gradient-to-tr from-blue-900 via-blue-600 to-cyan-400 text-white flex-shrink-0">
                      <svg
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        className="w-5 h-5"
                        viewBox="0 0 24 24"
                      >
                        {card.icono}
                      </svg>
                    </div>
                    <h2 className="text-gray-900 text-lg title-font font-semibold">{card.titulo}</h2>
                  </div>
                  <p className="leading-relaxed text-base text-gray-700">{card.texto}</p>
                </div>

                {/* Capa hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-600 to-cyan-500 text-white p-6 flex items-center justify-center text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-base font-medium">{card.hoverTexto}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Compromiso;
